import { Component, Input } from "@angular/core";

import { BaseComponent, HelperService, ProductService, StorageService, StorageKeys, UserService } from "@mypxplat/xplat/core";
import { AppService, BetaService } from "@mypxplat/xplat/web/core";
import { Router } from "@angular/router";
import { BetaEnrollComponent, FeatureUpdatesComponent, LinkFenderAccountComponent, SubmitFeedbackComponent, ThemeChooserComponent } from "../modals";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { AngularFireAuth } from "@angular/fire/compat/auth";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { signOut } from "aws-amplify/auth";
import { TranslateService } from "@ngx-translate/core";
import { takeUntil } from "rxjs";

@Component({
  selector: "myp-cloud-nav-overlay",
  templateUrl: "cloud-nav-overlay.component.html",
  standalone: false,
})
export class CloudNavOverlayComponent extends BaseComponent {
  @Input() admin: boolean = false;
  @Input() fender: boolean = false;
  public isBetaManager: boolean;
  public themes: Array<any> = [
    { name: "Auto", id: "auto", translateKey: "com.auto_theme" },
    { name: "Dark", id: "plaindark", translateKey: "com.dark_theme" },
    { name: "Light", id: "plainlight", translateKey: "com.light_theme" },
  ];
  public selectedTheme = "auto";
  constructor(
    userService: UserService,
    private _storage: StorageService,
    public appService: AppService,
    public helperService: HelperService,
    public router: Router,
    public betaService: BetaService,
    public db: AngularFirestore,
    public fbAuth: AngularFireAuth,
    public productService: ProductService,
    private translate: TranslateService
  ) {
    super(userService);
  }

  ngOnInit() {
    if (this.betaService.enrolledBetaFeatures && this.betaService.enrolledBetaFeatures.length && this.betaService.enrolledBetaFeatures.filter((item: any) => item.manager).length) {
      this.isBetaManager = true;
    }
    this.selectedTheme = this.appService.selectedTheme;
    this.themes.forEach((item) => (item.id == this.selectedTheme ? (item.selected = true) : (item.selected = false)));
    const keys = this.themes.map((t) => t.translateKey);

    this.translate
      .stream(keys)
      .pipe(takeUntil(this.destroy$))
      .subscribe((dict) => {
        this.themes = this.themes.map((t) => ({
          ...t,
          name: dict[t.translateKey],
        }));
      });
  }

  manageCookies() {
    if ((<any>window).Osano?.cm.showDrawer) {
      (<any>window).Osano.cm.showDrawer("osano-cm-dom-info-dialog-open");
    }
  }

  selectTheme(id) {
    this.appService.initTheme(id);
    this.selectedTheme = this.appService.selectedTheme;
    this.themes.forEach((item) => (item.id == this.selectedTheme ? (item.selected = true) : (item.selected = false)));
    this.userService.saveUser({ id: this.user.id, theme: id }).subscribe((result) => {});
  }

  linkFenderAccount() {
    this.close(false, true);
    const modalRef = this.appService.showModal(LinkFenderAccountComponent, { size: "lg" });
  }

  close(args, force?) {
    if ((args && args.target.className == "cloud-nav-overlay") || (args && args.target.className == "cloud-nav-positioner") || force) {
      this.appService.showNavOverlay = false;
    }
  }

  openSubmitFeedback() {
    const modalRef = this.appService.showModal(SubmitFeedbackComponent, { size: "lg" });
  }

  openBeta() {
    const modalRef = this.appService.showModal(BetaEnrollComponent, { size: "lg" });
  }

  viewAllAnnouncements() {
    let modal = this.appService.showModal(FeatureUpdatesComponent, { size: "lg", ariaLabelledBy: "modal-title" });
    modal.componentInstance.showingAll = true;
  }

  showPrivacySettings() {
    (<any>window).UC_UI.showSecondLayer();
  }

  openUrl(url) {
    window.open(url);
  }

  showThemeChooser() {
    this.appService.showThemeChooser(ThemeChooserComponent);
  }

  async logout() {
    await signOut();
    this.userService.logout().subscribe(() => {
      this.appService.redirectToConnect(false, true);
    });
  }

  ngOnDestroy() {
    this.appService.showNavOverlay = false;
  }
}
